import styled from 'styled-components';
import OuterLink from '../Link/OuterLink';
export const SocialContainer = styled.div `
  display: ${({ isVisibleOnMobile }) => (isVisibleOnMobile ? 'flex' : 'none')};
  ${({ theme }) => theme.media.tablet `
  display:flex;
`}
  flex-direction: ${({ isFixed }) => (isFixed ? 'column' : 'row')};
  gap: 1.3rem;
  position: ${({ isFixed }) => (isFixed ? 'absolute' : 'unset')};
  top: ${({ absoluteTop }) => `${absoluteTop}rem`};
`;
export const CustomSocialIconlinks = styled(OuterLink) `
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  &:last-child {
    margin: 0;
  }
`;
export const SocialIconContainer = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 4rem;
  height: 4rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.surface.default};
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
`;
//# sourceMappingURL=styles.js.map